import {hasQuotePermission, isQuotePermission} from '../utils/quote-access';
import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {SessionService} from "../services/session.service";

@Injectable({
  providedIn: 'root'
})
export class CanActivateService {
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const requiredPermission: string | undefined = next.data['requiredPermission'];
    const ownerOnly: boolean = next.data['ownerOnly'];
    const renteeRestricted: boolean = next.data['renteeRestricted'];
    const redirectTo = '/dashboard';
    const currentUrl = state.url;

    const isLoggedIn = this.sessionService.isLogin.getValue();
    const currentUser = this.sessionService.currentUser.getValue();

    if (!isLoggedIn) {
      if (currentUrl !== '/sign-in') {
        await this.router.navigate(['/sign-in']);
      }
      return false;
    }

    const user = currentUser?.user;
    const isOwner = user?.is_owner;
    const isOnlyRentee = !user?.is_owner && !!user?.is_rentee;
    const permissions = user?.permission?.split(',') || [];

    if (requiredPermission && (!permissions.includes(requiredPermission)
      || (isQuotePermission(requiredPermission) && !hasQuotePermission(user, requiredPermission)))) {
      if (currentUrl !== redirectTo) {
        await this.router.navigate([redirectTo]);
      }
      return false;
    }

    if (ownerOnly && !isOwner) {
      if (currentUrl !== redirectTo) {
        await this.router.navigate([redirectTo]);
      }
      return false;
    }

    if (renteeRestricted && isOnlyRentee) {
      if (currentUrl !== redirectTo) {
        await this.router.navigate([redirectTo]);
      }
      return false;
    }

    return true;
  }
}

export const CanActivateGuard: CanActivateFn = async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  return await inject(CanActivateService).canActivate(next, state);
}
